import React from "react";
import { Button } from "antd";
import {
	CaretLeftOutlined,
	CaretRightOutlined,
	HomeOutlined,
} from "@ant-design/icons";

export const PrevButton = ({ decrementPage, visible, disabled }) => {
	return visible ? (
		<Button
			name="Prev"
			onClick={decrementPage}
			type="ghost"
			className="qna-button-nav margin-left-tiny"
			disabled={disabled}
		>
			<CaretLeftOutlined />
			Prev
		</Button>
	) : (
		<div></div>
	);
};

export const NextButton = ({ incrementPage, visible, disabled }) => {
	return visible ? (
		<Button
			name="Next"
			onClick={incrementPage}
			type="primary"
			className="qna-button-nav margin-right-tiny"
			disabled={disabled}
		>
			<CaretRightOutlined />
			Next
		</Button>
	) : (
		<div></div>
	);
};

export const HomeButton = ({ visible, disabled, onClick }) => {
	return visible ? (
		<Button
			name="Home"
			onClick={onClick}
			type="primary"
			className="qna-button-home margin-right-tiny"
			disabled={disabled}
		>
			<HomeOutlined />
		</Button>
	) : (
		<div></div>
	);
};

export const CustomButton = ({ visible, disabled, onClick, children }) => {
	return visible ? (
		<Button
			name="Home"
			onClick={onClick}
			type="primary"
			className="qna-button-nav margin-right-tiny"
			disabled={disabled}
		>
			{children}
		</Button>
	) : (
		<div></div>
	);
};
